import { MinusSquare } from '@phosphor-icons/react';

export default MinusSquare;
